export enum ViewVariant {
  CHART = "Chart",
  CHART_WITH_TABLES = "Chart with rate tables",
}
